(function () {
  'use strict';
  var openingFromDrawer = false;

  // Let Smile handle its documented deep links. Close Impulse's focus trap
  // first; its close animation restores focus after 500ms.
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-zr-rewards-link]');
    if (!link) return;
    if (link.getAttribute('aria-disabled') === 'true') {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var drawer = link.closest('#CartDrawer');
    if (!drawer || !drawer.classList.contains('drawer--is-open')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (openingFromDrawer) return;
    openingFromDrawer = true;
    document.dispatchEvent(new CustomEvent('cart:close'));
    window.setTimeout(function () {
      openingFromDrawer = false;
      // If the theme could not close the drawer, leave checkout usable.
      if (link.isConnected && !drawer.classList.contains('drawer--is-open')) link.click();
    }, 550);
  }, true);
}());
